/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import TooltipIcon from '@/views/components/TooltipIcon/TooltipIcon';

const DictionaryContainerHeader = () => {
	const { dict } = useSelector((state) => state.app);

	return (
		<div className='table__header-container'>
			<div className='table__dictionary__item head'>
				<div className='table__dictionary__item--col head'>
					{dict.dictionary.inputPhrase.toUpperCase()}
				</div>
				<div className='table__dictionary__item--col head'>
					{dict.dictionary.outputPhrase.toUpperCase()}
				</div>
				<div className='table__dictionary__item--col head'>
					{dict.dictionary.basicInputPhrase.toUpperCase()}
				</div>
				<div className='table__dictionary__item--col head'>
					{dict.dictionary.basicOutputPhrase.toUpperCase()}
				</div>
				<div className='table__dictionary__item--col head'>
					{dict.dictionary.comments.toUpperCase()}
				</div>
				<div className='table__dictionary__item--col head'>
					{dict.dictionary.count.toUpperCase()}
					&nbsp;
					<TooltipIcon
						tooltipText={ dict.dictionary.countTooltip }
					/>
				</div>
				<div className='table__dictionary__item--col head' />
			</div>
		</div>
	);
};

export default memo(DictionaryContainerHeader);